import { useEffect, useState } from 'react';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import { Card, CardBody } from '../../../../components/card/card';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { GetNtxPeoplesList } from '../../../../store/NTX/Peoples/peoplesSlice';
import NtxTable from '../../../../components/DataTable/NtxTable';
import Loading from '../../../../components/Shared/Loader/Loading';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
// import AddUpdateOwners from './AddUpdateOwners';
import AddUpdateOwners from '../../../NTX/Peoples/AddUpdateOwners';

const Index = () => {
  const { HasPermission } = usePermissions();
  const [Show, setShow] = useState(false);
  const [Id, setId] = useState('');

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(GetNtxPeoplesList(''));
  }, []);
  const { PeoplesList, loading } = useAppSelector(state => state.Peoples);

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = PeoplesList?.filter(f => f.typeCode === 'OWNERS')?.map(item => {
    let rowClass;

    return {
      Name: i18n.language === 'en' ? item.name : item.name2,

      action: (
        <button
          hidden={!HasPermission('FleetViewOwnerDetails')}
          type='button'
          className='btn btn-sm btn-outline-theme'
          data-bs-toggle='modal'
          data-bs-target='#modalEditOwners'
          // onClick={() => Navigate(`${item.id}/Edit`)}
          onClick={() => setId(item.id)}
        >
          <i className='far fa-lg fa-fw me-2 fa-edit'></i>
          {t('Button.Edit')}
        </button>
      ),

      rowClass // استخدم rowClass هنا
    };
  });
  //________________________________

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'Owners',
              link: null
            }
          ]}
          PageName='Owners'
        />
        <div className='ms-auto'>
          <a
            hidden={!HasPermission('FleetAddOwner')}
            href='#/'
            className='btn   btn-theme'
            data-bs-toggle='modal'
            data-bs-target='#modalِAddOwners'
            onClick={() => setShow(true)}
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('AddOwners')}
          </a>
        </div>
      </div>

      <Card>
        <Loading loading={loading}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddOwners')} id='modalِAddOwners' size='lg'>
        {<AddUpdateOwners />}
      </ModalComponent>
      <ModalComponent title={t('EditOwners')} id='modalEditOwners' size='lg'>
        {/* {Id && <EditOwners Id={Id} />} */}
        {Id && <AddUpdateOwners Id={Id} isUpdate />}
      </ModalComponent>
    </div>
  );
};

export default Index;
